import React from 'react'
import { Guardian } from '../../providers/context'
import { ConferenceInvites } from '../home/conferences'
import { useTranslation } from '../../providers/translation'
import { SimpleLayout } from '../../layouts/simple'

export const PTCFamilyHomePage: React.FC<{ user: Guardian; initialStudentID?: number }> = ({
  user,
  initialStudentID,
}) => {
  const { tr } = useTranslation('ptc')
  return (
    <SimpleLayout
      helpLink="https://reachmyteach.zendesk.com/hc/en-us/sections/38101452116249-Family"
      verticalScroll={false}
    >
      <div className="flex flex-col gap-2 sm:mx-auto sm:my-8 sm:min-w-[450px] sm:max-w-[600px] sm:rounded-lg sm:p-6 sm:shadow-special">
        <div className="text-xl font-bold sm:self-center -sm:ml-6 -sm:mt-4">{tr('Parent Teacher Conferences')}</div>
        <ConferenceInvites user={user} initialStudentID={initialStudentID} />
      </div>
    </SimpleLayout>
  )
}
